<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    data: {
        type: Object,
        default: null,
    },
    options: {
        type: Object,
        default: null,
    },
    plugins: {
        type: Array,
        default: null,
    },
    styles: {
        type: Object,
        default: null,
    },
    width:{
        type:Number,
        default:400
    },
    height:{
        type:Number,
        default:400
    }
  },
  watch:{
    'data': function() {
      this._chart.destroy();
      //this.renderChart(this.data, this.options);
      this.renderChart(this.data, this.options, this.plugins, this.styles, this.width);
    }
  },
  mounted(){
    this.renderChart(this.data, this.options, this.plugins, this.styles, this.width)
  }
}
</script>
